<template>
  <div class="client-container">
    <Header />
    <div class="client-box">
      <div class="client-img-box">
      <div class="container">
      <div class="item shade" @mouseover="enter()" @mouseleave="leave()">
        <div class="nduocu"></div>
        <img src="../../assets/home/pcad2.png" alt="">
        <div class="texts">
          &nbsp;&nbsp;&nbsp;&nbsp;暗度收集了1000多万条优质的2年以上闲置链接，旨在帮助亚马逊卖家高效低成本找到合适僵尸/闲置链接，再多站点合并和跨站点销售，助力卖家快速打爆产品
        </div>
        <div class="but" v-if="seen"><el-button round @click="knowmore">了解更多</el-button></div>
      </div>
      <div class="item">
        <img class="upgrading" src="../../assets/home/upgrading.png" alt="">
      </div>
      <div class="item">
      </div>
    </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue'
export default {
  name: 'client',
  components: {
    Header,
    Footer
  },
  props: {},
  data() {
    return {
      url:'https://andu365.com',
      seen :false
    }
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() {

  },
  methods: {
    knowmore(){
      window.open(this.url)
    },
    enter(){
        this.seen = true;
    },
    leave(){
      this.seen = false;
    }
  }
}
</script>

<style scoped lang="scss">
.client-container {
  padding-top: 80px;
  .client-box {
    display: flex;
    justify-content: center;
    padding-top: 20px;
    background: url('../../assets/use-course/course-bg.png') no-repeat;
    background-size: 100% 528px;
    .client-img-box {
      width: 1200px;
      height: 1000px;
      margin: 0 auto;
      img {
        width: 100%;
      }
    }
  }
}
  .container {
    display: flex;
    width: 1220px;
    margin-top: 60px;
    .item {
      position: relative;
      flex: 1;
      width: 380px;
      height: 380px;
      padding: 10px;
      background-color: #fff;
      margin-right: 30px;
      border-radius: 8px;
      box-shadow: 0px 3px 8px 0px rgba(255, 255, 255, 0.1), 0px 6px 26px 0px rgba(95, 139, 230, 0.16);
      .img{
        width: 360px;
        height: 250px;
        margin-bottom: 20px;
      }
      .texts{
        margin-top: 10px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #24232F;
        line-height: 24px
      }
      .upgrading{
        width: 150px !important;
        height: 100px;
      }
      .but{
        text-align: center;
        margin-top: -25px;
        position: absolute;
        left: 35%;
        z-index: 99;
        .el-button.is-round {
          color: #fff;
          background: linear-gradient(-64deg, #346AFB, #5187FB);
        }
      }
    }
    .item:nth-child(1) {
      background-size: 100% 100%;
    }
    .nduocu{
      width: 100%;
      height: 100%;
      position:absolute;
      top:0;
      left: 0;
      z-index: 6;
    }
    .shade:hover{
     transform: scale(1.1);
      .nduocu{
      background: #FFFFFF;
      box-shadow: 0px 3px 8px 0px rgba(255, 255, 255, 0.1);
      opacity: 0.6;
      border-radius: 8px;
      z-index: 9;
    }
    }
    .item:nth-child(2) {
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .footer-img {
        width: 114px;
        height: 80px;
        background-size: 100% 100%;
      }
    }
    .item:nth-child(3) {
      opacity: 0;
      background-size: 100% 100%;
      .footer-img {
        width: 120px;
        height: 80px;
        background-size: 100% 100%;
      }
    }
  }
</style>
